'use client';

import { createClient } from '@/lib/supabase/client';

export type CheckStatus = 'pass' | 'fail' | 'na' | '';

export interface CosmeticItem {
  id: string;
  vehicleReg: string;
  category: string;
  description: string;
  status: CheckStatus;
  notes: string;
  completed: boolean;
  reportedDate: string;
}

function rowToItem(row: Record<string, unknown>): CosmeticItem {
  return {
    id: row.id as string,
    vehicleReg: row.vehicle_reg as string,
    category: row.category as string,
    description: row.description as string,
    status: (row.status as CheckStatus) || '',
    notes: (row.notes as string) || '',
    completed: (row.completed as boolean) || false,
    reportedDate: (row.reported_date as string) || '',
  };
}

export async function getCosmeticItems(): Promise<CosmeticItem[]> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('cosmetic_items')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) {
    console.error('getCosmeticItems error:', error.message);
    return [];
  }
  return (data || []).map((r) => rowToItem(r as Record<string, unknown>));
}

export async function saveCosmeticItem(item: CosmeticItem): Promise<void> {
  const supabase = createClient();
  const { error } = await supabase.from('cosmetic_items').upsert({
    id: item.id,
    vehicle_reg: item.vehicleReg,
    category: item.category,
    description: item.description,
    status: item.status,
    notes: item.notes,
    completed: item.completed,
    reported_date: item.reportedDate,
  }, { onConflict: 'id' });
  if (error) console.error('saveCosmeticItem error:', error.message);
}

export async function getPendingCosmeticCount(): Promise<number> {
  const supabase = createClient();
  const { count } = await supabase
    .from('cosmetic_items')
    .select('*', { count: 'exact', head: true })
    .eq('completed', false);
  return count || 0;
}

// localStorage fallback
const STORAGE_KEY = 'fss_cosmetic_items_v1';

export function getCosmeticItemsLocal(): CosmeticItem[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveCosmeticItems(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: saveCosmeticItems is not implemented yet.', args);
  return null;
}

export { saveCosmeticItems };